import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";

@Injectable()
export class AccommodationCatService {
  constructor(private http: HttpClient) {}

  getAccommodationCategory() {
    return this.http.get(
      `/api/internalaccommodationcategory/getAccommodationCategory`,
      {
        responseType: "json",
        observe: "response"
      }
    );
  }

  addAccommodationCategory(data: any): Observable<Object> {
    return this.http.post(
      `/api/internalaccommodationcategory/addAccomodationCategory`,
      data
    );
  }

  editAccommodationCategory(data: any): Observable<Object> {
    return this.http.put(
      `/api/internalaccommodationcategory/editAccomodationCategory`,
      data,
      {}
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/services/accommodationcat.service.ts